import { Card } from '@magicschool/spellbook/components/Card';
import { Slot } from '@magicschool/spellbook/components/Slot';
import { popperContentMotionClassNames } from '@magicschool/spellbook/lib/popperContent';
import { cn } from '@magicschool/spellbook/lib/utils';
import * as HoverCardPrimitive from 'radix-ui/hover-card';

export const HoverCardTriggerSlot = Slot<React.ComponentProps<typeof HoverCardPrimitive.Trigger>>({
  displayName: 'HoverCard.Trigger',
  preventOverride: true,
  renderDefault: ({ ...props }) => {
    return <HoverCardPrimitive.Trigger data-spellbook-name="hover-card-trigger" {...props} />;
  },
});

export const HoverCardContentSlot = Slot<React.ComponentProps<typeof HoverCardPrimitive.Content>>({
  displayName: 'HoverCard.Content',
  preventOverride: true,
  renderDefault: ({ children, className, align = 'center', sideOffset = 4, ...props }) => {
    return (
      <HoverCardPrimitive.Portal data-spellbook-name="hover-card-portal">
        <HoverCardPrimitive.Content
          data-spellbook-name="hover-card-content"
          align={align}
          asChild
          sideOffset={sideOffset}
          className={cn(
            [
              ...popperContentMotionClassNames,
              'z-portal',
              'origin-(--radix-hover-card-content-transform-origin)',
              'shadow-popover',
              'outline-hidden',
              'border',
              'border-border-default',
              'rounded-card-md',
            ],
            className,
          )}
          {...props}
        >
          <Card>
            <Card.Content>{children}</Card.Content>
          </Card>
        </HoverCardPrimitive.Content>
      </HoverCardPrimitive.Portal>
    );
  },
});
